import React from "react";

function getLocalRank(props, user) {
  var supervisorId = "";
  if (user.type === 1) { // Es un supervisor
    supervisorId = user.id;
  } else if (user.type === 2 && user.supervisor ) { // Es un vendedor supervisado
    supervisorId = user.supervisor;
  }

  var rank = 999;
  var position = 0;
  for (var i = 0; i < props.ranking.length; i++) {
    var rankedUser = props.ranking[i];
    if (rankedUser.type === 2 && rankedUser.supervisor === supervisorId) {
      position++;
    }
    if (rankedUser.id === user.id) {
      rank = position;
      break;
    }
  }
  return rank;
}

function getGlobalRank(props, user) {
  var rank = 999;
  for (var i = 0; i < props.ranking.length; i++) {
    var rankedUser = props.ranking[i];
    if (rankedUser.id === user.id) {
      rank = i+1;
      break;
    }
  }
  return rank;
}

const Render = (props, context) => {
  const user = props.user;
  const globalRank = getGlobalRank(props, user);
  const localRank = getLocalRank(props, user);
  
  let mes = " (" + props.mes + ")";
  let products = props.goals.map(goal => goal.product.sap).sort();
  
  return (
    <li key={(props.user.id+"-"+props.periodo)} className="box borderBox">
      <div className="body pRel">
        
      <div class="body pal bodycontainer backgroundRankingCard pRel">
        <div class="escudo pRel mha fullWidth">
          <img
              src={`${
                user.avatar
                  ? user.avatar.icon
                  : "/avatars/escudo_vacio.png"
              }`}
              alt="Avatar del usuario."
              className="avatar displayBlock fullWidth mbl"
          />
          <p class="pAbs bgYellow avenirBK black goldCircle">
            {localRank}°
          </p>
        </div>
      </div>

      <h2 className="avenirBK violet alignCenter mbn userName">
        {props.user.name} {props.user.surname}
      </h2>
      <div className="horizontalCenter pam bold black gold">{globalRank} a nivel nacional <sup>*5</sup></div>
        {products.map(prod => (
          props.goals.filter(goal => {return goal.product.sap === prod;}).map(item => (
          <ul className="unstyled horizontalCenterFlex">

            {item.quantity > 0 && (
              <li className="progressAvanceLi">
                <div className="progressAvance">
                  <p>
                    <span className="violet">{item.product.name.replace(mes, "")}</span>
                    <span>  
                    </span>
                    {" "}
                    <span className="perc prs violet bold ">
                      {parseInt(
                        (item.quantityProgress * 100) / item.quantity,
                        10
                      )}%
                    </span>
                  </p>
                  <progress max="100" value={parseInt((item.quantityProgress * 100) / item.quantity, 10)} className="mtm mbl">
                      <div className="progressBar">
                        <span
                          style={{
                            width: `${parseInt(
                              (item.quantityProgress * 100) / item.quantity,
                              10
                            )}%`
                          }}
                        />
                      </div>
                    </progress>
                </div>
              </li>
            )}

            {item.buyers > 0 && (

                <li className="progressAvanceLi">
                <div className="progressAvance">
                  <p>
                    <span className="violet">{item.product.name.replace(mes, "")}</span>
                    <span>  
                    </span>
                    {" "}
                    <span className="perc prs violet bold ">
                      {parseInt(
                        (item.buyersProgress * 100) / item.buyers,
                        10
                      )}%
                    </span>
                  </p>
                  <progress max="100" value={parseInt((item.buyersProgress * 100) / item.buyers, 10)} className="mtm mbl">
                      <div className="progressBar">
                        <span
                          style={{
                            width: `${parseInt(
                              (item.buyersProgress * 100) / item.buyers,
                              10
                            )}%`
                          }}
                        />
                      </div>
                    </progress>
                </div>
                </li>
            )}
          </ul>
        ))))}
      </div>
    </li>
  );
};

Render.contextTypes = {};

export default Render;



// WEBPACK FOOTER //
// ./src/pages/Avances/Avance.js